// src/utils/albumData.ts
import type { Slot } from '../types';
import { TextElement } from "../types/TextElement";
import { ShapeElement } from "../types/ShapeElement";  // <-- import shape
import type { AlbumElement } from '../types/AlbumElement';
import { v4 as uuidv4 } from 'uuid';

export type OverlayType =
    | "black-border"
    | "white-border"
    | "boudoir-black"
    | "boudoir-white"
    | "distressed-black"
    | "distressed-white"
    | "blurry-white";

export interface PageOverlay {
    type: OverlayType;
    opacity: number;
}


export interface PageType {
    id: string;
    order?: number;
    backgroundColor: string;
    showBackground: boolean;
    backgroundImageSrc: string | null;        // small image for stage/editor
    backgroundOriginalSrc?: string | null;    // original image for export
    backgroundImageElement?: HTMLImageElement | null; // optional loaded image element
    backgroundOpacity: number;
    backgroundZoom: number;
    backgroundImageOriginalSize?: {           // original image size
        width: number;
        height: number;
    };
    backgroundOffsetX: number;   //  required
    backgroundOffsetY: number;   //  required           // new: offset Y for background
    slots: Slot[];
    gap?: number;   // <-- ADD THIS
    texts: TextElement[];
    shapes: ShapeElement[];
    elements: AlbumElement[];

    //  new overlay field
    overlay?: PageOverlay;
}



export function CreateInitialSpreads(count: number, startIndex = 0, backgroundColor = "#ffffff"): PageType[] {
    return Array.from({ length: count }, (_, index) => ({
        id: uuidv4 (),      // stable unique ID
        order: startIndex + index,    // for sorting/arranging
        backgroundColor,
        showBackground: true,
        backgroundImageSrc: null,
        backgroundOriginalSrc: null,
        backgroundOpacity: 1,
        backgroundZoom: 1,
        backgroundOffsetX: 0,   // initialize offsets
        backgroundOffsetY: 0,
        slots: [],
        texts: [],
        shapes: [],
        elements: [],
        overlay: undefined,
    }));
}

